var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPxItalian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 12.0006C24.0002 6.70326 20.5668 2.21088 15.8047 0.619629V23.3809C20.5668 21.7896 24.0002 17.2976 24.0002 12.0006Z",
    fill: "#E00024"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.0006C0 17.2976 3.43367 21.7896 8.19581 23.3809V0.619629C3.43367 2.21088 0 6.70326 0 12.0006Z",
    fill: "#00873D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 24.0006C13.3303 24.0006 14.6082 23.7805 15.8046 23.3806V0.619658C14.6085 0.220104 13.3303 0 11.9998 0C10.6696 0 9.39107 0.220104 8.19531 0.619658V23.3809C9.39107 23.7805 10.6696 24.0006 11.9998 24.0006Z",
    fill: "#EDEDED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPxItalian);
export default __webpack_public_path__ + "static/media/px-italian.396a15873192a925615548a86ffeb8ed.svg";
export { ForwardRef as ReactComponent };